import React from "react";
import Hero from "../../components/hero/Hero";
import FindMemorial from "../../components/findmemorial/FindMemorial";
import Testimonials from "../../components/testimonials/Testimonial";
import Share from "../../components/sharetestimonial/Share";
import HowToUse from "../../components/howtouse/HowToUse";

function Homepage() {
  return (
    <>
      <Hero />
      <FindMemorial />
      {/* <Features /> */}
      <Testimonials />
      <Share />
      <HowToUse />
    </>
  );
}

export default Homepage;
